export { default as InsuranceOrderingEdit } from './InsuranceOrderingEdit';
export { default as InsuranceOrderingList } from './InsuranceOrderingList';
export { default as InsuranceOrderingUpload } from './InsuranceOrderingUpload';